import Person from "./Person";

export default class Contact extends Person {
    ownerId: number;

    constructor(data?: Partial<Contact>) {
        super(data);
        Object.assign(this, data);
    }
}
